export default "__VITE_ASSET__2c4f5614__"